import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import { Link, withRouter, Redirect} from "react-router-dom";
import moment from 'moment';
import {
    Breadcrumb,
    Button,
    Card,
    Grid,
    Header,
    Input,
    Message,
    Icon, Loader, Dimmer, Dropdown, Modal, Form
} from "semantic-ui-react";
import update from 'react-addons-update';
import Calendar from 'rc-calendar';
import DatePicker from 'rc-calendar/lib/Picker';
import TimePickerPanel from 'rc-time-picker/lib/Panel';
import esES from 'rc-calendar/lib/locale/es_ES';
import 'rc-calendar/assets/index.css';
import 'rc-time-picker/assets/index.css';
import 'moment/locale/es';
import 'sweetalert/dist/sweetalert.css';
import CustomDivider from "../../components/extras/CustomDivider";
import ViewPayments from "../../components/sale/ViewPayments";
import ClientOrder from "../../components/sale/ClientOrder";
import PrintSaleButtons from "../../components/sale/PrintSaleButtons";
import ProductsSale from "../../components/sale/ProductsSale";
import {FormattedDate, FormattedTime} from "react-intl";
import ProductOrderCard from "../../components/sale/ProductOrderCard";
import {connect} from "react-redux";
import {totalSale} from "../../actions/SaleTotalAction";
import SaleData from "../../data/SaleData";
import PrinterSettingsModal from "../../components/printer/PrinterSettingsModal";
import SendInvoiceByMail from "../../components/sale/SendInvoiceByMail";
import CancelSaleAlert from "../../components/sale/CancelSaleAlert";
import {cancelSale} from "../../actions/AlertCancelSaleAction";
import {saleCanceled} from "../../actions/SaleCanceledAction";
import {showToast} from "../../actions/ToastAction";
import localDB from "../../data/localDB";
import Loading from "../../components/extras/Loading";
import LoadingModal from "../../components/extras/LoadingModal";
import {showQuestionDialog} from "../../actions/QuestionDialogAction";
import DeliveryOrder from "../../components/sale/DeliveryOrder";
import DataService from "../../functions/DataService";

const now = moment();
now.locale('es').utcOffset(0);

class Sale extends Component {

    constructor(props) {
        super(props);
        this.state = {
            sale: JSON.parse(localDB.get('sale')),
            message_product: false,
            observation: '',
            index: 0,
            state_button_observation: false,
            loading: true,
            categories: [],
            category: {
                id: null,
            },
            show_loading_modal: false,
            loading_modal_message: '',
            search: '',
            search_by_barcode : false,
            moment: moment(),
            open_date: false,
            diff_days: null,
            tables: [],
            product_list: <Loading />,
            loading_view_payments: true,
            loading_view_client: true,
            modal_change_table: false,
            changing_table: false,
            next_table: null,
            next_table_error: false
        };

        this.handleCloseTable = this.handleCloseTable.bind(this);
        this.closeTable = this.closeTable.bind(this);
        this.handleDateOutClick = this.handleDateOutClick.bind(this);
        this.handleDateOutChange = this.handleDateOutChange.bind(this);
    }

    componentWillMount(){
        SaleData.get(this.state.sale.id, (sale) => {
            this.setState({sale, loading_view_payments:false, loading_view_client:false});
            this.props.totalSale(sale.total);
        });
        this.renderCategories();

        let suscription_date = moment(localDB.get('store').suscription_date);
        let diff_days = suscription_date.diff(now, 'days');
        this.setState({diff_days});
    }

    renderCategories = () =>{
        let categories = localDB.get('categories').filter(category => {return category.active}).map(category => {
            return (
                <Button
                    key={category.id}
                    onClick={() => {
                        this.setState({category, search: ''});
                        setTimeout(() => {
                            this.productList('', false);
                        }, 5);
                    }}
                    content={category.name}
                />
            )
        }, this);
        this.setState({categories});
        this.viewAllProducts();
    };

    componentWillReceiveProps(nextProps){
        if(nextProps.sale_canceled.canceled){
            this.props.cancelSale({show:false, id:0});
            this.props.saleCanceled({canceled:false});
            this.props.history.push('/sale');
        }
        if(nextProps.client_dialog){
            let sale = update(this.state, {
                sale: {
                    client: {
                        $set: nextProps.client_dialog
                    }
                }
            });
            this.setState(sale);
        }
        if(nextProps.question_dialog.confirm){
            this.closeTable();
        }
    }

    componentWillUnmount() {
        window.onpopstate  = (e) => {
            this.props.showQuestionDialog({ show: false });
        }
    }

    componentDidMount() {
        this.getTables()
    }

    async getTables(){
        let tables = await DataService.get(`api/change-tables`)
        tables = tables.map(d => {return {key:d.id, value:d.id, text:d.number}})
        this.setState({tables})
    }

    viewAllProducts = () => {
        let category = {
            name: 'Todos los Productos',
            id: null,
        };
        this.setState({category, search: ''});
        setTimeout(() => {
            this.productList('', false);
        }, 5);
    };

    productList = (search = '', search_by_barcode = false)  => {
        localDB.findProducts(search, this.state.category.id).then(products => {
            search_by_barcode = products.length === 1 && search_by_barcode;
            if (products.length > 0) {
                let product_list = products.map(product =>{
                    return <ProductOrderCard product={product} sale_id={this.state.sale.id} key={product.id} search_by_barcode={search_by_barcode} />
                });
                this.setState({product_list: <Card.Group itemsPerRow={4} style={{marginRight:1}} stackable doubling>{product_list}</Card.Group>})
            }
            else {
                this.setState({product_list: <Message icon='bell' header='No hay productos registrados'/>})
            }
            if(search_by_barcode){
                this.setState({search: ''});
                this.productList('', false);
            }
        });
    };

    handleCloseTable = () => {
        if(this.props.total_sale.balance > 0){
            this.props.showToast({
                message: `No puedes cerrar esta ${this.state.sale.type === 1 && this.state.sale.table.id !== 0 ? 'mesa':'orden'} porque hay un saldo pendiente!`,
                type: 'error'
            });
        }else{
            this.props.showQuestionDialog({
                show:true,
                text: `De cerrar esta ${this.state.sale.type === 1 && this.state.sale.table.id !== 0 ? 'mesa':'orden'}`,
                confirm_button_text: `Si, ${this.state.sale.type === 1 && this.state.sale.table.id !== 0 ? 'cerrar esta mesa':'finalizar esta orden'}`
            });
        }
    };

    closeTable() {
        this.setState({ loading_modal_message: 'Cerrando mesa...', show_loading_modal: true });
        let data = {};
        if(this.state.sale.type === 1 && this.state.sale.table.id !== 0){
            data = {
                order: {
                    sale: this.state.sale.id,
                },
                table: this.state.sale.table.id
            };
        }else{
            data = {
                order: {
                    sale: this.state.sale.id,
                },
                no_table: true
            };
        }

        SaleData.end(data, (res) => {
            if (res && res.update) {
                this.props.history.push('/sale');
            } else {
                this.setState({ show_loading_modal: false});
                this.props.showToast({
                    message: 'Tenemos un problema, inténtalo nuevamente!',
                    type: 'error'
                });
            }
        });
    };

    handleDateOutClick = (event) => {
        let client = update(this.state, {
            client: {
                birthdate: {
                    $set: event.format('YYYY-MM-DD')
                }
            }
        });
        this.setState(client);
    };

    handleDateOutChange = (event) => {
        this.setState({date:event.target.value});
        if (event.target.value.trim() === '') {
            this.setState({ birthdate_error: true })
        } else {
            this.setState({ date_error: false });
        }
    };

    typeOrder =() => {
        if (this.state.sale && this.state.sale.hasOwnProperty('table') && this.state.sale.table.number !== 0){
            return `Mesa Nº ${this.state.sale.table.number}`;
        }else{
            return `Orden Nº ${this.state.sale.billing_number}`;
        }
    };

    hasTable = () => {
        return this.state.sale && this.state.sale.hasOwnProperty('table') && this.state.sale.table.number !== 0
    }

    handleChange = (e, { name, value }) => {
        this.setState({[name]: value, next_table_error: false});
    };

    toggleChangeTable = () => {
        this.setState({modal_change_table: !this.state.modal_change_table})
    }

    handleChangeTable = () => {
        if(this.state.next_table){
            let data = {
                next_table: this.state.next_table,
                current_table: this.state.sale.table.id
            }

            this.setState({changing_table: true})
            DataService.post(data, 'api/change-tables', (res) => {
                if (res.changed) {
                    this.props.showToast({
                        message: `Mesa Cambiada!`,
                        type: 'success'
                    });
                    let sale = this.state.sale
                    sale.table.id = res.table.id
                    sale.table.number = res.table.number
                    this.setState({sale, next_table:null})
                    this.getTables()
                } else {
                    this.props.showToast({
                        message: `Tenemos un problema!`,
                        type: 'error'
                    });
                }
                this.toggleChangeTable();
                this.setState({changing_table: false})
            })
        }else{
            this.setState({next_table_error: true})
        }
    }

    handleCloseOrder = () => {
        if(this.state.sale.state === 1){
            return (
                <span>
                    <br/>
                    <Button size='large' primary fluid onClick={this.handleCloseTable}>{`${this.state.sale.type === 1 && this.state.sale.table.id !== 0 ? 'CERRAR MESA':'FINALIZAR ORDEN'}`}</Button>
                    <br/>
                </span>
            )
        }else{
            return null;
        }
    };

    render() {
        if (!localDB.get('rol_access').includes('sale_edit_after_close') && this.state.sale.state === 2) {
            return <Redirect to='/access-denied' />;
        }
        return (
            <div>
                <Helmet>
                    <title>Bisttros - Venta</title>
                </Helmet>
                { localDB.get('navigation') === 'sale' ?
                    <p>
                        <Button.Group>
                            <Button as={Link} to='/sale'>
                                <Icon name='chevron circle left' />
                                Vender
                            </Button>
                            <Button.Or text='' />
                            <Button.Group primary>
                                <Button primary>{this.typeOrder()}</Button>
                                {this.hasTable() ? <Dropdown className='button icon' floating>
                                    <Dropdown.Menu>
                                        <Dropdown.Item icon='exchange' text='Cambiar de Mesa' onClick={this.toggleChangeTable}/>
                                    </Dropdown.Menu>
                                </Dropdown>:null}
                            </Button.Group>
                        </Button.Group>
                    </p>:
                    <Breadcrumb>
                        <Breadcrumb.Section as={Link} to='/sales'>Finanzas</Breadcrumb.Section>
                        <Breadcrumb.Divider/>
                        <Breadcrumb.Section as={Link} to='/sales/history'>Histórico de Ventas</Breadcrumb.Section>
                        <Breadcrumb.Divider/>
                        <Breadcrumb.Section active>{this.typeOrder()}</Breadcrumb.Section>
                    </Breadcrumb>
                }
                <CustomDivider/>
                <div style={{margin:'0px 10px'}}>
                    <Grid columns={this.state.sale.state === 1 ? 2:1}>
                        <Grid.Row>
                            { this.state.sale.state === 1 ?
                                <Grid.Column>
                                    <div className="scrollmenu">
                                        <Button.Group size='small'>
                                            <Button primary onClick={() => this.viewAllProducts()}>Ver Todo</Button>
                                            {this.state.categories}
                                        </Button.Group>
                                    </div>
                                    <Grid.Row>
                                        <CustomDivider/>
                                        <Input fluid placeholder={`Buscar en ${this.state.category.name}`}
                                               value={this.state.search}
                                               autoFocus
                                               onKeyDown={(e) =>{
                                                   if(e.key==='Enter' && this.state.search.trim() !== ''){
                                                    this.productList(this.state.search, true)
                                                   }
                                               }}
                                               onChange={(e, {value}) => {
                                                   this.setState({search: value});
                                                   this.productList(value, false);
                                               }}/>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Header as='h2' textAlign='center' style={{marginTop: '5px'}}>
                                            {this.state.category.id ? this.state.category.name : 'Todos los Productos'}
                                        </Header>
                                        <div style={{paddingLeft:2, paddingTop:2}}>
                                            {this.state.product_list}
                                        </div>
                                    </Grid.Row>
                                    {this.state.diff_days <= 0 ?<Grid.Row>
                                        <p>
                                            <br/>
                                            <Message negative icon>
                                                <Icon name='frown outline'/>
                                                <Message.Content>
                                                <Message.Header>
                                                    TU SUSCRIPCIÓN HA CADUCADO!
                                                </Message.Header>
                                                <p>Es posible que no se muestren todos tus productos</p>
                                                    <Link to='/settings/suscription'>Renovar mi suscripción</Link>
                                                </Message.Content>
                                            </Message>
                                        </p>
                                    </Grid.Row>: null}
                                </Grid.Column>:null
                            }
                            <Grid.Column>
                                <Card.Group itemsPerRow={2} stackable doubling>
                                    <Card>
                                        <Card.Content>
                                            <ViewPayments
                                                sale={this.state.sale}
                                                show_payment={true}
                                            />
                                            { this.state.sale.type === 3 ? <div>
                                                <br/>
                                                <DatePicker
                                                    animation="slide-up"
                                                    defaultValue={moment(this.state.sale.open_date)}
                                                    calendar={
                                                        <Calendar
                                                            timePicker={<TimePickerPanel
                                                                defaultValue={moment('00:00', 'h:mm a')}
                                                                format='h:mm a'
                                                                use12Hours={true}
                                                                showSecond={false}
                                                                showToday={false}
                                                                disabled={false}
                                                            />}
                                                            locale={esES}
                                                            format='YYYY-MM-DD h:mm a'
                                                            dateInputPlaceholder={this.state.sale.open_date}
                                                            onOk={(event)=>{
                                                                if(event){
                                                                    let date_out = event.format('YYYY-MM-DD HH:mm');
                                                                    SaleData.deliveryUpdate({id:this.state.sale.id, date_out:date_out}, 'date_out', (res) => {
                                                                        if(res && res.update){
                                                                            let sale = update(this.state, {
                                                                                sale: {
                                                                                    date_out: {
                                                                                        $set: date_out
                                                                                    }
                                                                                }
                                                                            });
                                                                            this.setState(sale);
                                                                        }else {
                                                                            this.refs.alert.open({message:'Tenemos un problema!', type:'error'});
                                                                        }
                                                                    });
                                                                    this.setState({open_date:false});
                                                                }else{
                                                                    this.props.showToast({
                                                                        message: 'Por favor seleccione una fecha!',
                                                                        type: 'error'
                                                                    });
                                                                }
                                                            }}
                                                            onClear={()=>{
                                                                this.setState({open_date:false});
                                                            }}
                                                        />
                                                    }
                                                    onChange={newTime => this.setState({date: newTime})}
                                                >{
                                                    ({value}) => {
                                                        return (
                                                            <Button primary size='small' fluid animated='fade'>
                                                                <Button.Content visible><Icon name='calendar' /> Fecha de Entrega</Button.Content>
                                                                <Button.Content hidden>
                                                                    <FormattedDate value={value}/> - <FormattedTime value={value}/>
                                                                </Button.Content>
                                                            </Button>
                                                        )
                                                    }
                                                }</DatePicker>
                                            </div>:null
                                            }
                                        </Card.Content>
                                        <Dimmer active={this.state.loading_view_payments} inverted>
                                            <Loader size='mini'>Cargando</Loader>
                                        </Dimmer>
                                    </Card>
                                    <Card>
                                        <Card.Content>
                                            <strong>Fecha: </strong><FormattedDate value={this.state.sale.date ? this.state.sale.date : Date()} /><br />
                                            <strong>Hora: </strong><FormattedTime value={this.state.sale.date ? this.state.sale.date : Date()}/><br/>
                                            <strong>Meser@: </strong>{this.state.sale.waiter ? this.state.sale.waiter.full_name.substring(0, 50) : 'No Aplica'}<br/>
                                            <strong>Personas: </strong>{this.state.sale.quantity}
                                            <ClientOrder
                                                client={this.state.sale.client}
                                                index={0}
                                                sale={this.state.sale.id}
                                                ref='client'
                                                saving={false}
                                                can_delete={true}
                                            />
                                            {[2, 10, 11].includes(this.state.sale.type) ?<DeliveryOrder
                                                delivery={this.state.sale.delivery}
                                                sale={this.state.sale.id}
                                                ref='delivery'
                                            />:null}
                                            <CustomDivider/>
                                            <PrintSaleButtons sale={this.state.sale.id} notes={this.state.sale.notes}/>
                                        </Card.Content>
                                        <Dimmer active={this.state.loading_view_client} inverted>
                                            <Loader size='mini'>Cargando</Loader>
                                        </Dimmer>
                                    </Card>
                                </Card.Group>
                                <CustomDivider/>
                                {this.handleCloseOrder()}
                                <div>
                                    <ProductsSale sale={this.state.sale}/>
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </div>
                <PrinterSettingsModal />
                <SendInvoiceByMail />
                <CancelSaleAlert />
                <LoadingModal message={this.state.loading_modal_message} show={this.state.show_loading_modal}/>

                <Modal size='tiny' open={this.state.modal_change_table} dimmer='inverted'>
                    <Modal.Header>Cambiar de Mesa</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Form.Select
                                                label='Mesa'
                                                name={'next_table'}
                                                options={this.state.tables}
                                                onChange={this.handleChange}
                                                value={this.state.next_table}
                                                error={this.state.next_table_error}
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.toggleChangeTable} content="Cancelar"/>
                        <Button primary icon='exchange' labelPosition='left' onClick={this.handleChangeTable} content='Cambiar de Mesa' loading={this.state.changing_table} disabled={this.state.changing_table}/>
                    </Modal.Actions>
                </Modal>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        products_sale: state.get('products_sale'),
        total_sale: state.get('total_sale'),
        sale_canceled: state.get('sale_canceled'),
        select_client: state.get('select_client'),
        question_dialog: state.get('question_dialog'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        totalSale(total) {
            dispatch(totalSale(total));
        },
        showToast(data) {
            dispatch(showToast(data));
        },
        cancelSale(data) {
            dispatch(cancelSale(data));
        },
        saleCanceled(data){
            dispatch(saleCanceled(data));
        },
        showQuestionDialog(data) {
            dispatch(showQuestionDialog(data));
        },
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Sale))



// WEBPACK FOOTER //
// ./src/containers/sale/Sale.js